import { render, staticRenderFns } from "./CurrentRequests.html?vue&type=template&id=12886058&scoped=true&external"
import script from "./CurrentRequests.js?vue&type=script&lang=js&external"
export * from "./CurrentRequests.js?vue&type=script&lang=js&external"
import style0 from "./CurrentRequests.vue?vue&type=style&index=0&id=12886058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12886058",
  null
  
)

export default component.exports